export default __webpack_public_path__ + "static/media/pic50.9280cd18.JPG";